import Api from '@/util/Api'
import GraphQL from '@/util/GraphQL'
export default class BuildingHeightApiService {

  storeOrUpdate(payload = null) {
    payload = payload ?? this
    if(payload.id) return Api.post(`/api/admin/building_height/update/${payload.id}`, { ...payload })
    return Api.post(`/api/admin/building_height/store`, { ...payload })
  }

  show(building_height_id = null) {
    building_height_id = building_height_id ?? this.id
    const query = `
      {
        building_height (find: ${building_height_id}) {
          id
          title
          slug
          content
        }
      }
    `
    return GraphQL({ query })
  }


}